import { render } from "./simpleAudio.vue?vue&type=template&id=6fb9c894"
import script from "./simpleAudio.vue?vue&type=script&lang=js"
export * from "./simpleAudio.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__